module.exports = __webpack_public_path__ + "static/media/refresh.3fa66365.svg";